


























import CompanyUserRequired from "../CompanyRequired";
import {Component, Emit, Inject, Prop} from "vue-property-decorator";
import Api from "@/components/terminals/Api";

@Component
export default class SyncInfoDialog extends CompanyUserRequired {
    @Inject()
    api!: Api;

    @Prop({default: false})
    value!: boolean;

    get opened() {
        return this.value;
    }
    set opened(v: boolean) {
        this.$emit("input", v);
    }

    @Prop()
    terminalGuid!: string;

    @Prop({default: false})
    simNotActive!: boolean;

    async pushconfig() {
        await this.api.terminalConfigPush(this.terminalGuid);
        this.opened = false;
    }
}
